import React from 'react';
import GuideSvg from '@/assets/imgs/guide.svg';
import PathSvg from '@/assets/icons/path.svg';
import { useTranslation } from '@/i18n';
import { acquireCluster } from '@/utils';

const LayoutLeft: React.FC = () => {
  const { t } = useTranslation('i18n_ecom_shop_email');
  const isTTP = acquireCluster() === 'ttp';

  return (
    <div className="flex flex-col w-[285px] items-center mr-40">
      <img
        src={GuideSvg}
        className="mb-20"
        width={286}
        height={285}
        loading="eager"
        decoding="sync"
        // @ts-ignore fetchpriority is a valid attribute but missing in older React typings
        fetchPriority="high"
        alt=""
      />
      <div className=" text-p1-semibold text-neutral-text1 mb-3">
        {t('contact_us_content_title', 'How can we help?')}
      </div>
      <div className="text-p3-regular text-neutral-text3 text-center mb-3">
        {isTTP
          ? t('description_on_email_webform', 'Please fill out the form and we will get back to you.')
          : t('contact_us_content_text', 'Please fill out the form and we will get back to you.')}
      </div>
      <img src={PathSvg} width={24} height={7} loading="eager" decoding="async" alt="" />
    </div>
  );
};

export default LayoutLeft;
